import { PlanetFitnessPromo } from "../../common/PlanetFitnessPromo";
import ErrorMsg from "../../common/ErrorMsg";
import React from "react";
import Document from "../../common/Document";
import TemplateRequirement from "../../common/TemplateRequirement";
import { Flex, Button } from "@chakra-ui/react";
import { RuleError } from "../../utils/RuleErrors";
import { useApiUser } from "../../context/ApiAuthContext";
import { useQuery } from "react-query";
import { useTranslation, Trans } from "react-i18next";
import { Redirect, useHistory } from "react-router-dom";
import Loader from "../../common/Loader";
import Stepper from "../../common/Stepper";
import { _basePath } from "../../config/index";
import { rulesApiClient } from "../../apiConfig";
import { UserContext } from "../../context";

const CheckInRules = ({ user, loggedIn }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const apiUser = useApiUser();
  const { tenantId, customerName } = apiUser;
  const { userData, setUserData } = React.useContext(UserContext);
  const [isInvalid, setIsInvalid] = React.useState([]);
  const [currStep, setCurrStep] = React.useState(0);

  const onCancel = () => {
    setUserData({ user: null, loggedIn: false });
    history.push(_basePath);
  };
  const { isLoading, isError, refetch } = useQuery(
    ["schedule_rules", user?.id],
    () =>
      rulesApiClient.userApiRuleEvaluatorPost(tenantId, "1.0", "en-US,en", {
        resources: [
          {
            category: userData?.user?.category,
            id: userData?.user?.id,
            name: `${userData?.user?.firstName} ${userData?.user?.lastName}`,
            partitionKey: userData?.user?.partitionKey,
            subCategory: userData?.user?.subCategory,
          },
        ],
        startTime: new Date().toISOString(),
        stage: "Entry",
      }),
    {
      onSuccess: (data) => {
        const invalidRules = data?.data?.data?.details?.filter(
          (rule) => !rule.isValidated // && !rule.isHandled
        );
        setIsInvalid(invalidRules);
        setUserData({
          ...userData,
          ...{
            rulesToken: data?.data?.data?.id,
            requirementTypeId: data?.data?.data?.requirementTypeId,
          },
        });
      },
    }
  );

  const onSuccess = () => {
    const isLast = currStep === isInvalid?.length - 1;
    if (isLast) {
      setIsInvalid([]);
      refetch();
    } else {
      setCurrStep(currStep + 1);
    }
  };

  if (!loggedIn) {
    return <Redirect to={_basePath} />;
  }
  if (isLoading) {
    return (
      <Flex w={"full"} h={"full"}>
        <Loader text={t("loader.checking_in", "Checking in...")} />
      </Flex>
    );
  }
  if (isError) {
    return (
      <Flex w={"full"} h={"full"} direction={"column"} alignItems={"center"}>
        <ErrorMsg
          message={t(
            "error.document_get",
            "Error retrieving required document, please see a staff member for assistance."
          )}
        >
          <Button
            variant={"kioskPrimary"}
            onClick={onCancel}
            data-testid={"error-cancel"}
          >
            <Trans i18nKey={"actions.cancel"}>Cancel</Trans>
          </Button>
        </ErrorMsg>
      </Flex>
    );
  }
  if (isInvalid.length) {
    return (
      <Stepper step={currStep}>
        {isInvalid.map((rule) => {
          switch (rule.ruleId) {
            case "Radianse.RulesEngine.Core.TemplateRequirements":
              return (
                <TemplateRequirement
                  key={rule.ruleId}
                  document={rule}
                  onComplete={onSuccess}
                  onCancel={onCancel}
                />
              );
            case "Radianse.RulesEngine.Core.RequireDocuments":
              return (
                <Document
                  key={rule.ruleId}
                  document={rule}
                  onSuccess={onSuccess}
                  onCancel={onCancel}
                />
              );
            case "Radianse.RulesEngine.Core.ServicesConfigRule":
              // TODO: conditional loading based on string matching isn't ideal, This should be much more dynamic and moved to a dynamically loaded federated component
              if (customerName === "Planet Fitness") {
                return (
                  <PlanetFitnessPromo key={rule.ruleId} onCancel={onCancel} />
                );
              } else {
                return (
                  <RuleError
                    ruleId={rule.ruleId}
                    key={rule.ruleId}
                    onCancel={onCancel}
                  />
                );
              }
            default:
              return (
                <RuleError
                  ruleId={rule.ruleId}
                  key={rule.ruleId}
                  onCancel={onCancel}
                />
              );
          }
        })}
      </Stepper>
    );
  }
  return <Redirect to={`${_basePath}/appointment/events`} />;
};

export default CheckInRules;
